import React, { useState } from "react";
import {
  FacebookOutlined,
  LinkedinOutlined,
  ShareAltOutlined,
  TwitterOutlined,
} from "@ant-design/icons";

function ShareGroupButton({ url, title = "" }) {
  url = encodeURIComponent(url);
  title = encodeURIComponent(title);
  const source = window.origin.href;

  const [shareIsOpen, setShareIsOpen] = useState(false);

  return (
    <div className="wrap-share-buttons">
      <button
        className={`btn btn-menu ${shareIsOpen && "active"}`}
        onClick={() => {
          setShareIsOpen(!shareIsOpen);
        }}
      >
        <ShareAltOutlined />
        <i className="fa fa-bars" />
      </button>
      <button
        className="btn sub-btn fb"
        onClick={(e) => {
          e.preventDefault();
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
        }}
      >
        <FacebookOutlined />
      </button>
      <button
        className="btn sub-btn ld"
        onClick={(e) => {
          e.preventDefault();
          window.open(
            `http://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${title}&source=${source}`
          );
        }}
      >
        <LinkedinOutlined />
      </button>
      <button
        className="btn sub-btn tw"
        onClick={(e) => {
          e.preventDefault();
          window.open(`https://twitter.com/share?url=${url}&text=${title}`);
        }}
      >
        <TwitterOutlined />
      </button>
    </div>
  );
}

export default ShareGroupButton;
